/*
 * Validate a "go back here" path before navigating to it.
 *
 * App.js declares no catch-all `<Route path="*">`, so navigating to a path that
 * matches no route renders a BLANK page the user cannot escape from. Back
 * targets that travel through router state / session storage are therefore
 * untrusted input and must be checked:
 *
 *   - must be an in-app absolute path ("/x"); a protocol-relative "//host"
 *     would leave the app entirely,
 *   - must not be the screen we're currently on, which makes Back look dead.
 *
 * Anything that fails falls back to `fallback` — by default /fast-agent-detail,
 * the app home, which resolves its own agent / dashboard / fork routing on
 * mount and is safe for every logged-in user.
 */
export const safeBackPath = (
    raw,
    { fallback = "/fast-agent-detail", avoid = "" } = {}
) => {
    const isSafe =
        typeof raw === "string" &&
        raw.startsWith("/") &&
        !raw.startsWith("//") &&
        (!avoid || !raw.startsWith(avoid));
    return isSafe ? raw : fallback;
};

export default safeBackPath;
